import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow-down-circle",
  "use": "icon-icon-arrow-down-circle-usage",
  "viewBox": "0 0 16.4 16.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.4 16.4\" id=\"icon-icon-arrow-down-circle\">\r\n    <defs>\r\n        <style>#icon-icon-arrow-down-circle .cls-1,#icon-icon-arrow-down-circle .cls-2{fill:none;stroke:#000;stroke-miterlimit:10;}#icon-icon-arrow-down-circle .cls-2{stroke-linecap:round;}</style>\r\n    </defs>\r\n    <title>资源 1</title>\r\n    <g id=\"icon-icon-arrow-down-circle_图层_2\" data-name=\"图层 2\">\r\n        <g id=\"icon-icon-arrow-down-circle_图层_1-2\" data-name=\"图层 1\">\r\n            <circle class=\"cls-1\" cx=\"8.2\" cy=\"8.2\" r=\"7.7\" />\r\n            <path class=\"cls-2\" d=\"M4.8,7.2l3.1,3.3a.5.5,0,0,0,.7,0l3-3.3\" />\r\n        </g>\r\n    </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-arrow-down-circle.svg
// module id = Fkem
// module chunks = 75